import CommonAPIService from './CommonHandler';

export class DocumentationAPIService {
  constructor() {
    this.search = '';
    this.CommonAPIService = new CommonAPIService();
  }

  // gets all the documentation
  getDocumentation(router) {
    const url = '/api/documentation';
    return this.CommonAPIService.getCall(url, '', router);
  }

  getDocumentationByProgram(program_id, router) {
    const url = `/api/documentation/${program_id}/program`;
    return this.CommonAPIService.getCall(url, '', router);
  }

  saveDocumentationToTechniques(techniques, router) {
    const url = `/api/documentation/technique`;
    return this.CommonAPIService.postCall(url, {techniques: techniques}, router);
  }

  getDocumentationByID(documentation_id, router) {
    const url = `/api/documentation/${documentation_id}`;
    return this.CommonAPIService.getCall(url, '', router);
  }

  saveDocumentationToPrograms(programs, router) {
    const url = '/api/documentation/program';
    return this.CommonAPIService.postCall(url, {programs: programs}, router);
  }

  addDocumentation(documentation, router) {
    const url = '/api/documentation';
    return this.CommonAPIService.postCall(url, documentation, router);
  }

  updateDocumentation(documentation_id, parms, router) {
    const url = `/api/documentation/${documentation_id}`;
    return this.CommonAPIService.putCall(url, parms, router);
  }
  linkDocumentationToProgram(documentation_id, program_id, router) {
    const url = `/api/documentation/${documentation_id}/${program_id}/program`;
    return this.CommonAPIService.getCall(url, '', router);
  }
  deleteDocumentationToProgram(documentation_id, program_id, router) {
    const url = `/api/documentation/${documentation_id}/${program_id}/program`;
    return this.CommonAPIService.deleteCall(url, '', router);
  }
  updateDocumentationToProgram(data, program_id, router) {
    const url = `/api/documentation/${program_id}/toprogram`;
    return this.CommonAPIService.putCall(url, data, router);
  }

  deleteDocumentation(documentation_id, router) {
    const url = `/api/documentation/${documentation_id}`;
    return this.CommonAPIService.deleteCall(url, '', router);
  }
  updateTestedOnDocumentation(documentation_id, program_id, tested, router) {
    const url = `/api/documentation/${documentation_id}/${program_id}/${tested}/tested`;
    return this.CommonAPIService.putCall(url, null, router);
  }
}

export default DocumentationAPIService;
